export const RESET_SESSION_STORAGE_KEY = "passwordResetSession";

export function loadPasswordResetSession() {
  const storedSession = sessionStorage.getItem(RESET_SESSION_STORAGE_KEY);
  if (!storedSession) {
    return null;
  }

  try {
    const parsedSession = JSON.parse(storedSession);
    if (parsedSession?.resetSessionToken && parsedSession?.email) {
      return parsedSession;
    }
  } catch (_) {
    // Ignore malformed stored session and clear it below.
  }

  sessionStorage.removeItem(RESET_SESSION_STORAGE_KEY);
  return null;
}

export function savePasswordResetSession(session) {
  if (!session?.resetSessionToken || !session?.email) {
    return;
  }

  sessionStorage.setItem(RESET_SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function clearPasswordResetSession() {
  sessionStorage.removeItem(RESET_SESSION_STORAGE_KEY);
}
